export function getObjBykeys (obj, keys = [], initialValue = {}) {
  const value = {}
  keys.forEach(key => {
    value[key] = obj[key] || undefined
  })
  return { ...value, ...initialValue }
}

export function getMenus (data, config, deep = 0) {
  if (!data || !data.length) {
    return []
  }

  const menus = data
    .filter(find => (config.useNewMenu === 1 ? find.updateFlag === 1 : find) && (find.platformCode === 'SSO_SYS_USER_BASE' ? find.selectFlag === 2 : true))
    .map((menu) => {
    let key = `m_${menu.menuId}`
    const menuName = {
      'zh_CN': menu.menuName,
      'en_US': menu.menuEnName,
      'ko_KR': menu.menuKrName
    }
    const deepLevel = deep
    const tab = menuName[config.lang] || menuName['zh_CN'] || key
    // const childMenus = (menu.lastMenu === 2 && []) || (menu.childMenus && getMenus(menu.childMenus, config, deep + 1))
    const childMenus = ((menu.lastMenu === 2 && menu.platformCode !== 'SSO_SYS_USER_BASE') && []) || (menu.childMenus && getMenus(menu.childMenus, config, deep + 1))
    // const special = (!childMenus.some(find => find.special === 2) && deepLevel < 3) ? 1 : 2
    const special = menu.special || 1
    const icon = (menu?.menuIcon || '').replace(/^http:\/\//, window.location.protocol + '//') || (menu.lastMenu === 1 ? 'thunderbolt' : '')
    const pushpin = menu.collectFlag && menu.collectFlag === 2
    const tabVisible = typeof config.tabVisible === 'boolean' ? config.tabVisible : true
    let updateFlag = !childMenus.length ? menu.updateFlag : (childMenus.some(so => so.updateFlag === 1) ? 1 : 2)
    let systemDomain = '' // 域名
    let systemCode = menu.systemCode
    let menuUrl = '' // 路径
    let path = `/entry/${config.serviceId}/${config.systemCode}` // 动态路由
    let functionClass = []
    if (menu.lastMenu === 2) {
      functionClass = menu.functionClass
    }
    // 处理跳转URL地址
    // if (/^\/embel/.test(menu.menuUrl) && menu.systemCode === 'SAAS_PLATFORM_AUTH') {
    //   path += `/sso-web#${menu.menuUrl}`
    // }
    if (menu.platformCode === 'SSO_SYS_USER_BASE' && menu.lastMenu === 2) {
      menuUrl = menu['menuUrl'] || ''
      menuUrl = menuUrl.substring(menuUrl.lastIndexOf('/'))
      updateFlag = 1
      if (menuUrl === '/storeManagement') {
        menuUrl = '/account-store'
      }
      path += `/sso-web#/embel${menuUrl}`
      systemCode = 'SSO_SYS_USER'
      // key += '_sso'
    } else if (menu.menuUrl?.startsWith('http')) {
      systemDomain = new URL(menu.menuUrl).origin
      menuUrl = `${menu.menuUrl}`
      path += `/iframe#${key}`
      if (menu.systemCode === 'SAAS_PLATFORM_AUTH') {
        menuUrl = `${menu.menuUrl.replace(/^(.*?)#/, window.location.protocol + '//' + window.location.host + '/#')}`
      }
    } else if (menu.systemDomain) {
      systemDomain = menu.systemDomain.startsWith('http') ? menu.systemDomain : `${window.location.protocol}//${menu.systemDomain}`
      menuUrl = `${systemDomain}${menu.menuUrl}`
      path += `/iframe#${key}`
    } else {
      const appConfig = config.microApps.find(item => item.systemCode === menu.systemCode)
      systemDomain = ''
      menuUrl = menu.menuUrl
      path += appConfig ? `/${appConfig.name}#${menu.menuUrl}` : '/404'
    }

    // 特殊处理home.proxy.eccang.com
    if (['home.proxy.eccang.com', 'pre-home.proxy.eccang.com'].includes(window.location.host)) {
      menuUrl = menuUrl?.replace(/.eccang.com/i, '.proxy.eccang.com')
    }

    return getObjBykeys(
      menu,
      ['menuId', 'platformExpireTime', 'assetsExpireTime', 'lastMenu', 'updatePackageIds'],
      { key, tab, systemDomain, icon, menuUrl, path, menuName, childMenus, special, pushpin, tabVisible, closable: true, hidden: config.hidden || false, updatePackageId: config.packageId, updateFlag, deepLevel, functionClass, systemCode }
    )
  })

  return menus
}

const paneKeys = [
  'key',
  'tab',
  'systemDomain',
  'path',
  'menuId',
  'menuName',
  'icon',
  'menuUrl',
  'platformExpireTime',
  'assetsExpireTime',
  'pushpin',
  'hidden',
  'functionClass'
]
export function findPane (menus = [], target, config = {}, plusPaneKeys = []) {
  if (!menus || !menus.length) return undefined
  let pane
  const targetKeys = Object.keys(target)
  const targetString = JSON.stringify(target)
  const defaultConfig = { closable: true }
  config = { ...defaultConfig, ...config }

  menus.forEach(menu => {
    const menuObject = getObjBykeys(menu, targetKeys)
    const menuString = JSON.stringify(menuObject)

    if (pane) {

    } else if (targetString === menuString) {
      pane = getObjBykeys(menu, [...plusPaneKeys, ...paneKeys], { ...config })
    } else if (menu.childMenus && menu.childMenus.length && findPane(menu.childMenus, target)) {
      pane = findPane(menu.childMenus, target, { ...config }, plusPaneKeys)
    }
  })

  return pane
}

export function filterPane (menus, target, config = { closable: true }) {
  if (!menus || !menus.length) return []

  const panes = []
  const targetKeys = Object.keys(target)
  const targetString = JSON.stringify(target)

  menus.forEach(menu => {
    const menuObject = getObjBykeys(menu, targetKeys)
    const menuString = JSON.stringify(menuObject)

    if (targetString === menuString) {
      panes.push(getObjBykeys(menu, paneKeys, { ...config }))
    } else if (menu.childMenus && menu.childMenus.length) {
      panes.push(...filterPane(menu.childMenus, target, { ...config }))
    }
  })

  return panes
}
